<template>
  <v-container fluid>
    <v-container v-if="adminCashflowProjectionReport">
      <h1>TOTAL: {{ total }}</h1>
      <highcharts v-if="adminCashflowProjectionReport" :options="getChart()"></highcharts>
      <v-btn @click="download" :disabled="loadingCSV">Download CSV</v-btn>
    </v-container>
  </v-container>
</template>

<script>

import { CASHFLOW_PROJECTION_QUERY, CASHFLOW_PROJECTION_CSV_QUERY } from "@/graphql/queries/billing";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";

export default {
  name: "CashFlowProjection",
  mixins: [FileDownloadMixin],
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      adminCashflowProjectionReport: null,
      loadingCSV: false,
      total: 0
    };
  },
  methods: {
    getChart() {

      let colors = ["blue", "green", "purple", "cyan", "red", "orange", "yellow", "magenta"];
      let colorsCopy = [...colors];
      let data = {};
      let categories = [];
      this.adminCashflowProjectionReport.days.forEach(day => {
        categories.push(day.date);
        day.products.forEach(product => {
          if (data[product.title] === undefined) {
            if (colors.length === 0)
              colors = [...colorsCopy]
            data[product.title] = {data: [], name: product.title, color: colors.pop()};
          }
          data[product.title].data.push([day.date, product.amount]);
        });
      });

      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Cashflow projection",
        },
        xAxis: {
          categories: categories,
        },
        yAxis: {
          title: {
            text: "Expected Income",
          },
        },
        credits: {
          enabled: false,
        },
        series: Object.values(data),
      };
    },
    download() {
      this.loadingCSV = true;
      this.$apollo
        .query({
          query: CASHFLOW_PROJECTION_CSV_QUERY,
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.loadingCSV = false;
            let fname = `${this.startDate}_${this.endDate}_projection.csv`;
            let dataString = data.data.adminCashflowProjectionReportCsv;
            this.downloadBase64File("application/csv", dataString, fname);
          }
        });
    }
  },
  apollo: {
    adminCashflowProjectionReport: {
      query: CASHFLOW_PROJECTION_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
      result(response) {
        if (response.data.adminCashflowProjectionReport && !response.data.loading) {
          let total = response.data.adminCashflowProjectionReport.grandTotal.toFixed(2);
          total = new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(total);
          this.total = total;
        }
      }
    },
  },
}
</script>
